import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAbnahmeListStatus: 'idle',
    loadAbnahmeListError: undefined as any,
    loadAbnahmeListLastArgs: undefined as any,
    loadAbnahmeStatus: 'idle',
    loadAbnahmeError: undefined as any,
    saveAbnahmeStatus: 'idle',
    saveAbnahmeError: undefined as any,
    deleteAbnahmeStatus: 'idle',
    deleteAbnahmeError: undefined as any,

    abnahmeList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAbnahmeList = createAsyncThunk('auftragAbnahmeSlice/loadAbnahmeList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragAbnahmeSlice.loadAbnahmeListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/abnahme/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAbnahmeListStatus } = getState().auftragAbnahmeSlice
        return loadAbnahmeListStatus !== 'pending'
    }
})

export const loadAbnahme = createAsyncThunk('auftragAbnahmeSlice/loadAbnahme', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/abnahme/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAbnahmeStatus } = getState().auftragAbnahmeSlice
        return loadAbnahmeStatus !== 'pending'
    }
})

export const saveAbnahme = createAsyncThunk('auftragAbnahmeSlice/saveAbnahme', async ({ abnahme }: any, { rejectWithValue }: any) => {
    let promises = []
    if (abnahme?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/abnahme/${ abnahme?.HDR_ID }/`,
            prepareData(abnahme),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/abnahme/`,
            prepareData(abnahme),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAbnahmeStatus } = getState().auftragAbnahmeSlice
        return saveAbnahmeStatus !== 'pending'
    }
})

export const deleteAbnahme = createAsyncThunk('auftragAbnahmeSlice/deleteAbnahme', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/abnahme/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAbnahmeStatus } = getState().auftragAbnahmeSlice
        return deleteAbnahmeStatus !== 'pending'
    }
})

const AbnahmeSlice = createSlice({
    name: 'auftragAbnahmeSlice',
    initialState,
    reducers: {
        resetloadAbnahmeListError: (state) => {
            state.loadAbnahmeListError = undefined
        },
        resetloadAbnahme: (state) => {
            state.formItem = undefined
            state.loadAbnahmeError = undefined
        },
        resetloadAbnahmeError: (state) => {
            state.loadAbnahmeError = undefined
        },
        resetsaveAbnahme: (state) => {
            state.formItem = undefined
            state.saveAbnahmeError = undefined
        },
        resetsaveAbnahmeError: (state) => {
            state.saveAbnahmeError = undefined
        },
        resetdeleteAbnahmeError: (state) => {
            state.deleteAbnahmeError = undefined
        },
        removeFromAbnahmeListById: (state, action) => {
            state.abnahmeList = state.abnahmeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAbnahmeListByIds: (state, action) => {
            state.abnahmeList = state.abnahmeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.abnahmeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAbnahmeListStatus = 'preloaded'
            state.loadAbnahmeListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.abnahmeList = []
            state.loadAbnahmeListStatus = 'idle'
            state.loadAbnahmeListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAbnahmeList.pending, (state) => {
            state.loadAbnahmeListStatus = 'pending'
            state.loadAbnahmeListError = undefined
        })
        builder.addCase(loadAbnahmeList.fulfilled, (state, action) => {
            state.loadAbnahmeListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAbnahmeListLastArgs = action.payload.args

            {
                state.abnahmeList = action.payload.data

            }
        })
        builder.addCase(loadAbnahmeList.rejected, (state, action) => {
            state.loadAbnahmeListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAbnahmeListError = action.error.message
            } else {
                state.loadAbnahmeListError = action.payload
            }
        })

        builder.addCase(loadAbnahme.pending, (state) => {
            state.loadAbnahmeStatus = 'pending'
            state.loadAbnahmeError = undefined
        })
        builder.addCase(loadAbnahme.fulfilled, (state, action) => {
            state.loadAbnahmeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abnahmeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abnahmeList.push(newItem) }
                else { state.abnahmeList[i] = { ...state.abnahmeList[i], ...newItem } }
            }
        })
        builder.addCase(loadAbnahme.rejected, (state, action) => {
            state.loadAbnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAbnahmeError = action.error.message
            } else {
                state.loadAbnahmeError = action.payload
            }
        })

        builder.addCase(saveAbnahme.pending, (state) => {
            state.saveAbnahmeStatus = 'pending'
            state.saveAbnahmeError = undefined
        })
        builder.addCase(saveAbnahme.fulfilled, (state, action) => {
            state.saveAbnahmeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abnahmeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abnahmeList.push(newItem) }
                else { state.abnahmeList[i] = { ...state.abnahmeList[i], ...newItem } }
            }
        })
        builder.addCase(saveAbnahme.rejected, (state, action) => {
            state.saveAbnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAbnahmeError = action.error.message
            } else {
                state.saveAbnahmeError = action.payload
            }
        })

        builder.addCase(deleteAbnahme.pending, (state) => {
            state.deleteAbnahmeStatus = 'pending'
            state.deleteAbnahmeError = undefined
        })
        builder.addCase(deleteAbnahme.fulfilled, (state, action) => {
            state.deleteAbnahmeStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.abnahmeList = state.abnahmeList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.abnahmeList = state.abnahmeList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAbnahme.rejected, (state, action) => {
            state.deleteAbnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAbnahmeError = action.error.message
            } else {
                state.deleteAbnahmeError = action.payload
            }
        })

    }
})

export const {
    resetloadAbnahmeListError,
    resetloadAbnahme,
    resetloadAbnahmeError,
    resetsaveAbnahme,
    resetsaveAbnahmeError,
    resetdeleteAbnahmeError,
    removeFromAbnahmeListById,
    removeFromAbnahmeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AbnahmeSlice.actions
export default AbnahmeSlice.reducer
